import React, { useState } from 'react';

import { DownloadIcon } from 'lucide-react';

import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from '../../../ui/alert-dialog.jsx';
import { Button } from '../../../ui/button.jsx';
import { Label } from '../../../ui/label.jsx';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../../../ui/select.jsx';

export default function DialogExportRecords({
  action,
  description,
  fileTypes = ['xlsx', 'csv'],
}) {
  const [exportDialogOpen, setExportDialogOpen] = useState(false);
  const [fileType, setFileType] = useState(fileTypes?.[0]);

  return (
    <AlertDialog open={exportDialogOpen} onOpenChange={setExportDialogOpen}>
      <AlertDialogTrigger asChild>
        <Button>
          <DownloadIcon />
          Exportar
        </Button>
      </AlertDialogTrigger>

      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Exportação</AlertDialogTitle>
          <AlertDialogDescription>{description}</AlertDialogDescription>
          {fileTypes?.length && (
            <div className="flex flex-col gap-4 py-4">
              <Label>Tipo de ficheiro</Label>
              <Select onValueChange={setFileType} value={fileType}>
                <SelectTrigger>
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  {fileTypes.map((type) => (
                    <SelectItem key={type} value={type}>
                      {type}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
          )}
          <AlertDialogDescription className="font-bold text-yellow-500">
            Esta processo poderá demorar algum tempo.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancelar</AlertDialogCancel>
          <Button
            onClick={async (event) => {
              event.preventDefault();
              action && action(fileType);
              setExportDialogOpen(!exportDialogOpen);
            }}
          >
            Exportar
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
